import { render, staticRenderFns } from "./TableFlagCell.vue?vue&type=template&id=32c6ba7a&"
import script from "./TableFlagCell.vue?vue&type=script&lang=js&"
export * from "./TableFlagCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports